import { compareAsc, parseISO } from 'date-fns';

export const API_VERSION = '1.0';
export const BASE_API_URL = `${process.env.REACT_APP_LL_API}`;
export const BASE_API = `${process.env.REACT_APP_LL_API}/${API_VERSION}`;

export const MERCURE_API = process.env.REACT_APP_MERCURE_API;

export const LeadLoopReportsLambdaEndpoint = 'https://qozsjvvgqmdpek2si6hehiuwni0borvg.lambda-url.us-west-1.on.aws/';

export function createReducer(initialState, reducerMap) {
  const appResetBlacklist = ['POST_LOGIN_FAIL', 'POST_LOGIN_SUCCESS', 'LOGOUT', 'LOGIN_SUCCESS', 'GET_MERCURE_TOKEN_SUCCESS'];
  let appendResetAction = true;
  if (reducerMap && typeof reducerMap === 'object') {
    const reducerKeys = Object.keys(reducerMap);
    reducerKeys.forEach((item) => {
      if (appResetBlacklist.includes(item)) {
        appendResetAction = false;
      }
    });

    if (appendResetAction === true) {
      if (!reducerMap.RESET_TO_INITIAL_STATE) {
        reducerMap.RESET_TO_INITIAL_STATE = (state, payload) => {
          return { ...initialState };
        };
      }
    }
  }

  return (state = initialState, action) => {
    const reducer = reducerMap[action.type];
    return reducer ? reducer(state, action.payload) : state;
  };
}

export const darkModeRouteParams = ['insights', 'pipelines', 'activity'];

const mileStoneFunnelColors = ['#0084ff', '#44bec7', '#ffc300', '#fa3c4c', '#d696bb', '#6699cc', '#13cf13', '#ff7e29', '#e68585', '#7646ff', '#20cef5', '#67b868', '#ff5ca1', '#a695c7'];

const colors = ['#02394A', '#044F66', '#50A1BA', '#6DD9F9', '#3b869c', '#e47ca2', '#8275ef', '#A4A3AF', '#397367', '#609FF7', '#63CCB7', '#5fc5b1', '#94A0B2', '#418C7D', '#DB8569', '#3363af', '#EADA7C', '#7AA5D6', '#F4BAD2', '#32ACBA', '#2ab1bb'];
const insightsColors = ['#5A189A', '#7B2CBF', '#9D4EDD', '#C77DFF', '#aab5ff', '#D8F3DC', '#B7E4C7', '#95D5B2', '#74C69D', '#52B788', '#40916C', '#2D6A4F', '#BEE9E8', '#62B6CB', '#1B4965', '#CAE9FF', '#5FA8D3'];
const colorsV2 = [
  '#3B48D7',
  '#44D2BE',
  '#F6B31F',
  '#C43BD7',
  '#00D6FF',
  '#272738',
  // Below are temporary colors
  '#F4BAD2',
  '#32ACBA',
  '#2ab1bb',
];

const graphColorsDarkBackground = ['#de425b', '#df485c', '#e14d5c', '#e2525d', '#e3575d', '#e45c5e', '#e6605f', '#e7655f', '#e86960', '#e96d61', '#ea7262', '#eb7662', '#ec7a63', '#ed7e64', '#ee8265', '#ef8666', '#f59e6d', '#f5a26f', '#f6a670', '#f7aa71', '#f8ae73', '#f8b275', '#f9b576', '#f9b978', '#fabd7a', '#fac17c', '#fbc57e', '#fbc880', '#fccc82', '#fcd085', '#fcd487', '#fdd88a', '#fddb8c', '#fddf8f', '#fde392'];

const graphColorsLightBackground = ['#00348c', '#0a398f', '#123d92', '#184295', '#1d4798', '#224b9b', '#26509e', '#2a55a0', '#2d5aa3', '#315fa6', '#3464a9', '#3769ac', '#3a6eaf', '#3d73b2', '#4078b5', '#437db8', '#4582bb', '#4f97c7', '#529cca', '#54a1cd', '#56a6cf', '#59acd2', '#5bb1d5', '#5db7d8', '#5fbcdb', '#61c1de', '#63c7e1', '#65cce4', '#67d2e7', '#69d7ea', '#6bdded', '#6de3f0', '#6fe8f3', '#71eef6', '#72f4f9', '#74f9fc', '#76ffff'];

function makeCRCTable() {
  let c;
  let crcTable = [];
  for (let n = 0; n < 256; n++) {
    c = n;
    for (let k = 0; k < 8; k++) {
      c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    }
    crcTable[n] = c;
  }
  return crcTable;
}

function crc32(str) {
  let crcTable = window.crcTable || (window.crcTable = makeCRCTable());
  let crc = 0 ^ -1;

  for (let i = 0; i < (str || '').length; i++) {
    crc = (crc >>> 8) ^ crcTable[(crc ^ str.charCodeAt(i)) & 0xff];
  }

  return (crc ^ -1) >>> 0;
}

export const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};

export function getColor(string, type, list = colors, hardSetGraphColors) {
  if (type) {
    list = colorsV2;
  }
  list = type === 'dark' ? graphColorsDarkBackground : graphColorsLightBackground;
  if (type === 'mileStoneFunnelColors') {
    list = mileStoneFunnelColors;
  }
  if (type === 'insightsColors') {
    list = insightsColors;
  }
  if (hardSetGraphColors) {
    list = hardSetGraphColors;
  }
  if (!list) {
    list = colors;
  }
  if (string === undefined) string = '';
  return list[crc32(string) % list.length];
}

export function shadeColor(color, percent, A) {
  let R = parseInt(color.substring(1, 3), 16);
  let G = parseInt(color.substring(3, 5), 16);
  let B = parseInt(color.substring(5, 7), 16);

  R = parseInt((R * (100 + percent)) / 100);
  G = parseInt((G * (100 + percent)) / 100);
  B = parseInt((B * (100 + percent)) / 100);

  R = R < 255 ? R : 255;
  G = G < 255 ? G : 255;
  B = B < 255 ? B : 255;

  let RR = R.toString(16).length === 1 ? '0' + R.toString(16) : R.toString(16);
  let GG = G.toString(16).length === 1 ? '0' + G.toString(16) : G.toString(16);
  let BB = B.toString(16).length === 1 ? '0' + B.toString(16) : B.toString(16);

  return '#' + RR + GG + BB;
}

export const isUrl = (string) => {
  const pattern = new RegExp('^(https?|chrome):\\/\\/[^\\s$.?#].[^\\s]*$', 'i');
  return !!pattern.test(string.replace(/\s+/g, ' ').trim());
};

export const setCurrentLocationToFirstOption = (serviceProviderLocations) => {
  const locationId = localStorage.getItem('pipeline_location_filter_id');
  if (locationId && locationId !== 'all') {
    if (serviceProviderLocations.length <= 1) {
      return serviceProviderLocations;
    }
    let index = serviceProviderLocations.findIndex((n) => n.id === locationId);
    if (index) {
      let copy = serviceProviderLocations.slice(0);
      copy.splice(0, 0, copy.splice(index, 1)[0]);
      return copy;
    } else {
      return serviceProviderLocations;
    }
  } else {
    return serviceProviderLocations;
  }
};

export const computeDatesSince = (lastOutgoing, lastIncoming) => {
  let type = 'no_communication';
  let last_datetime = null;
  if (lastOutgoing && lastIncoming) {
    if (compareAsc(parseISO(lastOutgoing), parseISO(lastIncoming))) {
      type = 'outbound';
      last_datetime = lastOutgoing;
    } else {
      type = 'inbound';
      last_datetime = lastIncoming;
    }
  } else if (lastOutgoing) {
    type = 'outbound';
    last_datetime = lastOutgoing;
  } else if (lastIncoming) {
    type = 'inbound';
    last_datetime = lastIncoming;
  }
  return { type, last_datetime };
};

// [key] = input placeholder value
export const inputHelpDescriptionMap = {
  // ['Wait Time']: 'Wait time description',
  // ['Wait Interval']: 'Wait time description',
};
